// Title.styles.js

import styled from 'styled-components';

const Paragraph = styled.p`
    font-size: 1em;
    font-family: 'Courier Prime', Courier, monospace;
`;

export default Paragraph;
